import React from 'react';
import { Link } from 'react-router-dom';
import PlatformVisual from './PlatformVisual';
import { useMarket } from '../../context/MarketContext';

const Hero: React.FC = () => {
  const { market } = useMarket();
  const isIndia = market === 'IN';

  return (
    <section className="relative pt-20 pb-16 sm:pb-24 overflow-hidden">

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-50 dark:bg-dark-800/50 border border-primary-200 dark:border-dark-700 mb-8 animate-fade-in">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          <span className="text-sm text-slate-700 dark:text-dark-300 font-medium">
            {isIndia ? 'Business operations, made simple' : 'AI-powered ERP and Payroll'}
          </span>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-display font-bold mb-6 animate-slide-up">
          <span className="text-slate-900 dark:text-white">Make everything</span>
          <br />
          <span className="gradient-text">Cimmple</span>
        </h1>

        {/* Subheading */}
        <p className="text-lg sm:text-xl text-slate-700 dark:text-dark-300 max-w-3xl mx-auto mb-10 animate-slide-up animate-delay-100">
          {isIndia
            ? 'Run pharmacy, manufacturing, and logistics operations with purpose-built Cimmple ERP products for India.'
            : 'From job tracking to payroll, Cimmple gives small and mid-sized businesses one simpler way to run daily operations.'}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-slide-up animate-delay-200">
          <Link to="/products" className="btn-primary text-lg px-8 py-4">
            Explore Products
            <svg className="inline-block ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
          <Link to="/pricing" className="btn-secondary text-lg px-8 py-4">
            View Pricing
          </Link>
        </div>

        {!isIndia && <PlatformVisual />}
      </div>
    </section>
  );
};

export default Hero;
